import useApi from "@/hooks/api/useApi";

export interface SupDicChainData {
  chain_id: number;
  name: string;
  is_L1: boolean;
  icon: string;
  rpcs: string[];
  explorers: string[];
}

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-eab22688-bacc-40d7-b842-1af400e430e9?ctx=documentation
 */
export default function useSupportedChains(enabled: boolean = true) {
  const { data, isLoading, isError, mutate, error } = useApi<SupDicChainData[], SupDicChainData[]>(
    {
      path: `/supported/chains/`,
      api: "v2",
    },
    {
      enabled,
      strategy: "cached",
    }
  );

  return {
    error,
    data,
    isLoading,
    isError,
    mutate,
  };
}
